<template>
  <v-dialog v-model="dialog" persistent="persistent" max-width="450px">
    <v-card>
      <ModelTitle title="Edit Screen" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field outlined autofocus :hide-details="nameErrors.length === 0" dense :error-messages="nameErrors"
              v-model="screen.name" label="Name"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-switch class="pa-0 ma-0" v-model="screen.isActive" label="Active Status"> </v-switch>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="save">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import ScreenService from '@/modules/MasjidImage/Screen/service.js'

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: 'edit-screen',
  props: {
    editDialog: {
      default: false,
    },
    editScreen: {
      type: Object,
    },
  },
  data() {
    return {
      screenId: null,
      dialog: false,
      loading: false,
      screen: {
        name: null,
        isActive: true,
      },
    }
  },
  mixins: [validationMixin],
  validations: {
    screen: {
      name: {
        required,
      },
    },
  },
  watch: {
    editDialog(val) {
      this.dialog = val
      if (val) {
        this.screenId = this.editScreen.id
        this.screen = JSON.parse(JSON.stringify(this.editScreen));
      }
    },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.screen.name.$dirty) return errors;
      if (!this.$v.screen.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  methods: {
    empty() {
      this.screen = {
        name: null,
        isActive: true,
      }
      this.$v.$reset()
    },
    close() {
      this.empty()
      this.$emit('close')
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return ScreenService.update(this.screenId, this.screen)
        .then((result) => {
          console.log('result is :', result)
          if (result.status) {
            this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
            }).fire({
              icon: 'success',
              title: 'Screen updated!',
            })
            this.loading = false;
            this.empty()
            this.$emit('updatedScreen')
          }
        }).catch((err) => {
          this.loading = false;
          this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          }).fire({
            icon: 'error',
            title: err.data.data,
          })
        })
      }
    },
  },

}
</script>

<style>
.slide-fade-enter-active {
  transition: all 2s ease;
}

.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translateY(30px);
  opacity: 0;
}

.v-expansion-panel__header {
  padding-left: 0px !important;
  padding-right: 0px !important;
}</style>
